// extracted by mini-css-extract-plugin
module.exports = {"root":"MirtGaugeChart_root_38Ezs","canvas":"MirtGaugeChart_canvas_2mOhl","info":"MirtGaugeChart_info_ppTnc","start":"MirtGaugeChart_start_FqdbT","end":"MirtGaugeChart_end_26CgF"};